// extracted by mini-css-extract-plugin
module.exports = {"alertError":"link-qr_alertError__YPtkc","loading":"link-qr_loading__2g9bb","homeLogo":"link-qr_homeLogo__XvPl0"};